export default __webpack_public_path__ + "03f29e4624ffa37f71d1f7c96b64ff2c.png";